import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import carousel_Img1 from "../../../assets/img/directsearch/carousel_1.avif";
import carousel_Img2 from "../../../assets/img/directsearch/carousel_2.avif";
import carousel_Img3 from "../../../assets/img/directsearch/carousel_3.avif";
import carousel_Img4 from "../../../assets/img/directsearch/carousel_4.avif";
import carousel_Img5 from "../../../assets/img/directsearch/carousel_5.avif";
import Section3_img1 from "../../../assets/img/directsearch/ds_sec3_img1.png";
import Section3_img2 from "../../../assets/img/directsearch/ds_sec3_img2.png";
import Section3_img3 from "../../../assets/img/directsearch/ds_sec3_img3.png";
import bgImage01 from "../../../assets/img/directsearch/landing/01.avif";
import bgImage02 from "../../../assets/img/directsearch/landing/02.avif";
import bgImage03 from "../../../assets/img/directsearch/landing/03.avif";
import bgImage04 from "../../../assets/img/directsearch/landing/04.avif";

import winterBgImage from "../../../assets/img/directsearch/winter.avif";
import { COLLECTION_TYPE } from "../../../assets/models/iCollection";
import { NFT_SELL_STATUS } from "../../../assets/models/iNft";
import { fireTagManagerEvent } from "../../../assets/Services/tagmanager";
import Button from "../../../assets/TakyonDesignSystem/components/Button/Button";
import Icon from "../../../assets/TakyonDesignSystem/components/Icon/Icon";
import ScrollContainer from "../../../assets/TakyonDesignSystem/components/ScrollContainer/ScrollContainer";
import TakContainer from "../../../assets/TakyonDesignSystem/components/TakContainer/TakContainer";
import { SMALL_SCREEN } from "../../../assets/Utils/generic";
import { type iWallSlot, WALL_SLOT_TYPE } from "../../../config/wall";
import { selectUser } from "../../../redux/slices/userSlice";
import openAuthModal, { AUTH_SECTION } from "../../components/Auth/Auth";
import Search from "./Search";
import { useSearchParams } from "react-router-dom";

const landingTypes = ["standard", "adv1", "adv2", "adv3"] as const;
type ladings = (typeof landingTypes)[number];

const landingBgs: Record<ladings, string[]> = {
  standard: [bgImage01, bgImage02, bgImage03, bgImage04],
  adv1: [bgImage01, bgImage02, bgImage03, bgImage04],
  adv2: [bgImage01, bgImage02, bgImage03, bgImage04],
  adv3: [winterBgImage],
};
//test
export default function Home() {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const isSmallScreen = useMediaQuery({ query: SMALL_SCREEN });
  const vSectionPadding = isSmallScreen ? "98px 0" : "160px 0";

  const [bgImageIndex, setBgImageIndex] = useState(0);

  const [mode, setMode] = useState<
    "standard" | "adv1" | "adv2" | "adv3" | undefined
  >();

  const [searchParams] = useSearchParams();

  const isExperienceTak = {
    "payload.type": COLLECTION_TYPE.experience,
  };
  const mixedTakgetInspired = {
    $or: [
      {
        $and: [
          {
            $or: [
              { "payload.type": { $exists: false } },
              { "payload.type": "hotel" },
              { "payload.type": null },
            ],
          },
          {
            $or: [
              { isHotelFakeSupply: { $exists: false } },
              { isHotelFakeSupply: false },
            ],
          },
        ],
      },
      {
        $and: [
          {
            $or: [
              { "payload.type": { $exists: false } },
              { "payload.type": "hotel" },
              { "payload.type": null },
            ],
          },
          {
            isHotelFakeSupply: true,
          },
        ],
      },
      {
        ...isExperienceTak,
        sellStatus: NFT_SELL_STATUS.FOR_SALE,
      },
    ],
    sellStatus: "FOR_SALE",
  };

  const stays: iWallSlot = {
    title: "secondary.stays_title",
    subtitle: "secondary.stays_subtitle",
    config: {
      type: WALL_SLOT_TYPE.CLASSIC,
      payload: {
        scroll: true,
        query: mixedTakgetInspired,
        sort: { isHotelFakeSupply: 1 },
        limit: 15,
      },
    },
  };

  const section3 = [
    {
      title: "ds.section_3_item1_title",
      subtitle: "ds.section_3_item1_subtitle",
      img: Section3_img1,
    },
    {
      title: "ds.section_3_item2_title",
      subtitle: "ds.section_3_item2_subtitle",
      img: Section3_img2,
    },
    {
      title: "ds.section_3_item3_title",
      subtitle: "ds.section_3_item3_subtitle",
      img: Section3_img3,
    },
  ];

  const adv_section3 = [
    {
      title: "ds.adv_section_3_item1_title",
      subtitle: "ds.adv_section_3_item1_subtitle",
      img: Section3_img1,
    },
    {
      title: "ds.adv_section_3_item2_title",
      subtitle: "ds.adv_section_3_item2_subtitle",
      img: Section3_img3,
    },
    {
      title: "ds.adv_section_3_item3_title",
      subtitle: "ds.adv_section_3_item3_subtitle",
      img: Section3_img2,
    },
  ];

  const section4 = [
    {
      hotel: "VRetreats",
      place: "Cervinia",
      title: t("ds.section_4_item1_title"),
      img: carousel_Img1,
      link: "https://www.vretreats.com/",
    },
    {
      hotel: "Villa Rosa Luxury Villas",
      place: "Grecia",
      title: t("ds.section_4_item2_title"),
      img: carousel_Img2,
      link: "https://villarosakos.gr/",
    },
    {
      hotel: "Palazzo Castri",
      place: "Firenze",
      title: t("ds.section_4_item3_title"),
      img: carousel_Img3,
      link: "https://www.palazzocastri.com/",
    },
    {
      hotel: "Hotel Giotto",
      place: "Assisi",
      title: t("ds.section_4_item4_title"),
      img: carousel_Img4,
      link: "https://www.hotelgiottoassisi.it/",
    },
    {
      hotel: "Grand Horizon",
      place: "Gran Canaria",
      title: t("ds.section_4_item5_title"),
      img: carousel_Img5,
      link: "https://www.grandhorizonresort.com/",
    },
  ];

  useEffect(() => {
    fireTagManagerEvent("landing_view", {
      user_id: user?._id ?? null,
    });
  }, []);

  useEffect(() => {
    const campaign = searchParams.get("utm_campaign");
    if (campaign === "B2C_promocode") {
      setMode("adv1");
      return;
    }
    if (campaign === "B2C_canalediretto") {
      setMode("adv2");
      return;
    }
    if (campaign === "B2C_Invernale") {
      setMode("adv3");
      return;
    }
    setMode("standard");
  }, [searchParams]);

  useEffect(() => {
    if (mode) {
      const interval = setInterval(() => {
        setBgImageIndex((p) => (p + 1) % landingBgs[mode].length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [mode]);

  if (!mode) {
    return (
      <div
        style={{
          minHeight: "100dvh",
          backgroundColor: "white",
          // marginTop: isShortScreen ? "44px" : "65px",
        }}
      />
    );
  }

  return (
    <div
      style={{
        minHeight: "100dvh",
      }}
    >
      {/* Hero */}
      <div
        className="d-flex flex-column justify-content-center align-items-center bg-white relative"
        style={{
          minHeight: `100dvh`,
        }}
      >
        {landingBgs[mode].map((src, i) => (
          <div
            key={src}
            className={`
              absolute transition-opacity duration-700 w-full h-full
              ${i === bgImageIndex ? "opacity-100" : "opacity-0"}
            `}
            style={{
              minHeight: "100dvh",
              backgroundImage: `url(${src})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transition: "background-image 500ms ease-in-out",
            }}
          />
        ))}
        <div
          className="flex flex-col items-center justify-center h-full w-full bg-[rgba(0,0,0,0.2)] z-10 absolute"
          style={{
            minHeight: `100dvh`,
          }}
        >
          <div className={`container ${isSmallScreen ? "" : "p-0"}`}>
            <div className="w100 d-flex flex-column white-color justify-content-center align-items-center regular">
              <div className="flex flex-col py-14 lg:pb-32 gap-4 items-center">
                {mode === "adv1" ? (
                  <div className="uppercase flex flex-col items-center">
                    <div className="flex flex-wrap gap-x-3 justify-center">
                      <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[800px] text-white mb-0">
                        {t("ds.adv_title2")}
                      </h1>
                      <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[800px] text-white mb-0">
                        <span className="italic">{t("ds.adv_title3")}</span>
                      </h1>
                    </div>
                  </div>
                ) : mode.includes("adv") ? (
                  <div className="uppercase flex flex-col items-center">
                    <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[1200px] text-white mb-0">
                      {t(`ds.${mode}_title2`)}
                    </h1>
                    <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[800px] text-white mb-0">
                      {t(`ds.${mode}_title3`)}
                    </h1>
                  </div>
                ) : mode === "adv3" ? (
                  <div className="uppercase">
                    <div className="flex flex-wrap gap-x-3 justify-center">
                      <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[800px] text-white mb-0">
                        {t("ds.adv3_title")}
                      </h1>
                      <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[800px] text-white mb-0">
                        {t("ds.adv3_title2")}
                      </h1>
                    </div>
                    <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[800px] text-white mb-0">
                      <span className="italic">{t("ds.adv3_title3")}</span>
                    </h1>
                  </div>
                ) : (
                  <div className="uppercase">
                    <div className="flex flex-wrap gap-x-3 justify-center">
                      <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[800px] text-white mb-0">
                        {t("ds.title")}
                      </h1>
                      <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[800px] text-white mb-0">
                        {t("ds.title2")}
                      </h1>
                    </div>
                    <h1 className="text-center font-extrabold text-3xl lg:text-[3.25rem] lg:leading-tight max-w-[800px] text-white mb-0">
                      <span className="italic">{t("ds.title3")}</span>
                    </h1>
                  </div>
                )}

                <p className="text-sm text-center text-white w-[80%]">
                  {mode === "standard"
                    ? t(`ds.subtitle`)
                    : t(`ds.adv_subtitle`)}
                </p>
              </div>
            </div>
            <div className="content d-flex flex-column align-items-center justify-content-center">
              <Search
                mode={isSmallScreen ? "mobile" : "desktop"}
                parent="home"
              />

              <div
                className="bg-white mt-md-0 d-none d-md-block hidden lg:block"
                style={{
                  padding: "11px 20px",
                  width: "fit-content",
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                }}
              >
                <p
                  className="fs-body-sm text-center"
                  dangerouslySetInnerHTML={{ __html: t("ds.promo") }}
                ></p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center">
          <div
            className="d-flex flex-column align-items-center justify-content-center cursor-pointer"
            onClick={() => {
              const section = document.getElementById("section-1");
              if (section) {
                const yOffset = -54;
                const y =
                  section.getBoundingClientRect().top +
                  window.pageYOffset +
                  yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
              }
            }}
          >
            <p className="fs-body text-white">{t("ds.findmore")}</p>
            <Icon color="white" size={30} icon={"keyboard_arrow_down"} />
          </div>
        </div>
      </div>
      {/* Body */}
      <div className="bg-white">
        <div className="d-flex flex-column">
          {/* Section 1 */}
          {mode !== "adv2" ? (
            <div
              id="section-1"
              className="container text-center d-flex align-items-center justify-content-center"
            >
              <div
                className="w-full"
                style={{
                  padding: vSectionPadding,
                }}
              >
                <p
                  className="fs-h1-lg fw-bolder"
                  dangerouslySetInnerHTML={{
                    __html: t("ds.section_1_title"),
                  }}
                ></p>
                <p
                  className="fs-body medium mt-3 mx-auto"
                  style={{ maxWidth: "460px" }}
                >
                  {t("ds.section_1_subtitle")}
                </p>
              </div>
            </div>
          ) : null}
          {/* Section 2 TAK */}
          {mode !== "adv2" ? (
            <div
              className="bg-black"
              style={{
                padding: vSectionPadding,
              }}
            >
              <TakContainer slot={stays} />
            </div>
          ) : null}
          {/* Section 3 */}
          <div className="container">
            <div
              className="text-center d-flex flex-column align-items-center justify-content-center"
              style={{
                padding: vSectionPadding,
              }}
            >
              <div className="w-full">
                <p className="fs-h1-lg fw-bolder">
                  {mode === "adv2"
                    ? t("ds.adv_section_3_title")
                    : t("ds.section_3_title")}
                </p>
              </div>
              <div
                className="d-flex flex-column flex-md-row gap-3 justify-content-between"
                style={{ marginTop: "60px" }}
              >
                {(mode === "adv2" ? adv_section3 : section3).map(
                  (item, index) => (
                    <div
                      key={index}
                      className="d-flex flex-column align-items-center bg-light-grey rounded p-4"
                    >
                      <img src={item.img} alt="" width="200" />
                      <p className="fs-h4 medium mt-2">{t(item.title)}</p>
                      <p
                        className="fs-body-sm mt-1 text-dark-grey"
                        style={{ lineHeight: "1.5" }}
                      >
                        {t(item.subtitle)}
                      </p>
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
          {/* Section 4 */}
          <div className="w-full">
            <ScrollContainer
              carousel={true}
              carouselDelay={5000}
              itemSize={window.innerWidth}
            >
              <div className="w-100 d-flex scroll-items">
                {section4.map((item, index) => (
                  <div
                    key={index}
                    className="d-inline-block flex-shrink-0"
                    style={{
                      width: "100%",
                      height: "calc(100dvh - 38px)",
                      position: "relative",
                      minWidth: "100%",
                      scrollSnapAlign: "center",
                    }}
                  >
                    <div
                      className="w-100 h-100"
                      style={{
                        background: `url(${item.img})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <div
                        className="w-100 h-100"
                        style={{
                          backgroundColor: "rgba(0,0,0,0.3)",
                        }}
                      >
                        <div className="container h-100">
                          <div
                            className="w-100 h-100 white-color d-flex flex-column justify-content-between align-items-center"
                            style={{
                              padding: vSectionPadding,
                              maxWidth: "100%",
                              overflow: "hidden",
                            }}
                          >
                            <div className="w-100 d-flex flex-column justify-content-between align-items-center">
                              <p
                                className="fs-h4 text-center"
                                style={{
                                  wordWrap: "break-word",
                                  hyphens: "auto",
                                  overflowWrap: "break-word",
                                  whiteSpace: "normal",
                                  width: "100%",
                                }}
                              >
                                {isSmallScreen ? (
                                  <>
                                    {t(item.hotel)}
                                    <br />
                                    {t(item.place)}
                                  </>
                                ) : (
                                  <>
                                    {t(item.hotel)} | {t(item.place)}
                                  </>
                                )}
                              </p>
                              <div className="mt-2">
                                <p
                                  className="fs-h1-lg fw-bold text-center"
                                  dangerouslySetInnerHTML={{
                                    __html: t(item.title),
                                  }}
                                  style={{
                                    overflowWrap: "break-word",
                                    whiteSpace: "pre-wrap",
                                  }}
                                ></p>
                              </div>
                            </div>
                            <Button
                              variant="light"
                              style={{
                                zIndex: 2,
                              }}
                              text={t("ds.section_4_button")}
                              onClick={() => {
                                fireTagManagerEvent("click_banner", {
                                  name: item.hotel,
                                  url: item.link,
                                });
                                window.open(item.link, "_blank");
                              }}
                            ></Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </ScrollContainer>
          </div>
          {/* Section 5 */}
          {/* <div className="container text-center d-flex align-items-center justify-content-center">
            <div
              className="w-full d-flex flex-column align-items-center"
              style={{
                padding: vSectionPadding,
              }}
            >
              <p
                className="fs-h1-lg fw-bolder"
                dangerouslySetInnerHTML={{ __html: t("ds.section_5_title") }}
              ></p>
              <p
                className="fs-body medium mt-3"
                style={{ marginTop: "60px", maxWidth: "60%" }}
              >
                {t("ds.section_5_subtitle")}
              </p>
            </div>
          </div> */}
          {/* Section 6 */}
          {!user && (
            <div className="bg-primary">
              <div className="container">
                <div
                  className="w-full d-flex flex-column align-items-center justify-content-between"
                  style={{
                    padding: vSectionPadding,
                    minHeight: isSmallScreen ? "550px" : "650px",
                  }}
                >
                  <div className="text-center d-flex flex-column align-items-center">
                    <p
                      className="fs-h1-lg fw-bolder"
                      style={{ maxWidth: isSmallScreen ? "100%" : "70%" }}
                      dangerouslySetInnerHTML={{
                        __html: t("ds.section_6_title"),
                      }}
                    ></p>
                    <p
                      className="fs-body medium mt-3"
                      style={{ marginTop: "60px" }}
                    >
                      {t("ds.section_6_subtitle")}
                    </p>
                  </div>
                  <Button
                    text={t("ds.section_6_email_button")}
                    variant="dark"
                    onClick={() => {
                      openAuthModal(AUTH_SECTION.register);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
